import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {appInjector} from "../../appInjector";
import {ToolsService} from "../../../services/toolsService/tools.service";
import {InfoWindow} from "./InfoWindow";
import {CesiumAdapterService} from "../../../services/cesiumAdapter21/cesium-adapter.service";
import {InfoWindowAfsComponent} from "./info-window-afs-component/info-window-afs.component";
import {MapObjectPlugin} from "../MapObjectPlugin";
export class MapInfoWindowPlugin extends AbstractMainPlugin {
  public object;
  private toolProvider;
  private view;

  public mapOverlay;

  private hasInfoWindow = false;
  private afsCo = null;
  // private currentTool;

  static getUsedComponents() {
    // return [];
    return [InfoWindowAfsComponent];
  }

  constructor(item:Item) {
    super(item);
    this.toolProvider = appInjector.get(ToolsService);
    this.view = appInjector.get(CesiumAdapterService);

    // item.getSubject(MapObjectPlugin.ANCHOR_SUBJECT).subscribe((position) => {
    //   if (!this.mapOverlay) {
    //     let overlayContent = (item.title) ? item.title : 'Unknown Object';
    //     this.mapOverlay = new InfoWindow(this.view, `marker-id-${this.item.id}`, {position: position}, overlayContent);
    //     this.mapOverlay.createInfoWindow();
    //     this.hasInfoWindow = true;
    //     if (!this.item.showTag) {
    //       this.mapOverlay.hideInfoWindow();
    //     }
    //   } else {
    //     this.mapOverlay.overlayChangePosition(position)
    //   }
    // });

      // item.emitter.subscribe((event)=>{
      //   let currentTool = this.toolProvider.getToolById(this.item.toolId);
      //   if (!this.hasInfoWindow){
      //     if (currentTool && currentTool.uses_info_window) {
      //       if (event.getEventName() == 'addedToItemManager') {
      //         // this.getPosition().then((object) => {
      //         //   let overlayContent = (item.title) ? item.title : currentTool.name;
      //         //   this.mapOverlay = new InfoWindow(this.view, `marker-id-${this.item.id}`, object, overlayContent);
      //         //   this.mapOverlay.createInfoWindow();
      //         //   this.hasInfoWindow = true;
      //         //   if(!this.item.showTag){ this.mapOverlay.hideInfoWindow(); }
      //         // });
      //       }
      //     }
      //   }
      //
      //   if (!this.isListenEvent()){
      //     return;
      //   }
      //
      //   if(event.getEventName() == 'infoAfsInitialized'){
      //     this.afsCo = event.getComponent();
      //     this.afsCo.isInitInfoWindow = this.hasInfoWindow;
      //     this.afsCo.isInfoVisible = event.getShowTag();
      //
      //     this.mapOverlay.emitter.subscribe((name)=>{
      //       if (name == 'onCloseClick'){
      //         this.mapOverlay.hideInfoWindow();
      //         this.afsCo.isInfoVisible = false;
      //         this.item.objectChanged();
      //       }
      //     })
      //   }
      //
      //   if (event.getEventName() == 'infoVisibilityChanged'){
      //     (event.getInfoVisibility()) ? this.mapOverlay.showInfoWindow() : this.mapOverlay.hideInfoWindow();
      //     this.afsCo.isInfoVisible = event.getInfoVisibility();
      //     this.item.objectChanged();
      //   }
      //
      //   if (event.getEventName() == 'objectPositionChanged'){
      //     // this.mapOverlay.overlayChangePosition();
      //   }
      //
      // })
  }

  public prepareItemConfig(config){
    if (this.afsCo){
      config.showTag = this.afsCo.isInfoVisible;
    }
  }

  private isListenEvent(){
    return this.mapOverlay && this.hasInfoWindow;
  }

  getAfterSetComponent(){
    return `<info-window-component [item]="item"></info-window-component>`
  }

  // todo: return position, not object
  // getPosition(){
  //   var self = this;
  //   return new Promise((resolve, reject)=>{
  //     for (let i=0; i < this.item.registeredPlugins.length; i++){
  //       let plugin = this.item.registeredPlugins[i];
  //       if (plugin.hasOwnProperty('mapObject')){
  //         if (!plugin.mapObject){
  //           setTimeout(()=>{
  //             self.getPosition().then((object)=>{
  //               resolve(object);
  //             });
  //           }, 100);
  //           return;
  //         }
  //         resolve(plugin.mapObject.object);
  //       }
  //     }
  //   })
  //
  // }

}
